
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRequestHeaders"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RequestHeaders"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shopId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xUserToken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xLangTag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gatewayUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetsPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"abTest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sentryDsn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sentryEnvironment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sentryTracingRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"features"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hrkDefaultCurrency"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exchangeRates"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EUR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"HRK"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureFlags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gatewayRouterProxyEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"spaRedirectWishlistToPd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"strictSalesDisplay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dualCurrencyPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conditionalVoucherDiscount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shadeFinderTryItFirstProductMasterIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newPdDesign"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"virtualTryOnState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"voucherNewDesign"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pdSetImmediateEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"klarnaNushopId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"googleRetailApiUserEvents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bazaarvoiceIntegrationPd"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"environment"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"bazaarvoiceCookieConsentMapping"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"swogoIntegrationEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recoProductDetailAddToCart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recoProductDetail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"swogoIgnoreConvertedPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pdHasAllReviewsPage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"livestreamOnPdEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mobileGalleryZoomEnabled"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1102}};
    doc.loc.source = {"body":"query getRequestHeaders {\n  RequestHeaders @client {\n    __typename\n    shopId\n    xUserToken\n    xLangTag\n    gatewayUrl\n    userId\n    userName\n    userEmail\n    assetsPath\n    abTest\n    sentryDsn\n    sentryEnvironment\n    sentryTracingRate\n    originUrl\n    mounts\n    role\n    features\n    hrkDefaultCurrency {\n      code\n      exchangeRates {\n        EUR\n        HRK\n      }\n    }\n    featureFlags {\n      __typename\n      gatewayRouterProxyEnabled\n      spaRedirectWishlistToPd\n      strictSalesDisplay\n      dualCurrencyPrice\n      conditionalVoucherDiscount\n      shadeFinderTryItFirstProductMasterIds\n      newPdDesign\n      virtualTryOnState\n      voucherNewDesign\n      pdSetImmediateEnabled\n      klarnaNushopId\n      googleRetailApiUserEvents\n      bazaarvoiceIntegrationPd {\n        siteId\n        locale\n        environment\n      }\n      bazaarvoiceCookieConsentMapping\n      swogoIntegrationEnabled\n      recoProductDetailAddToCart\n      recoProductDetail\n      swogoIgnoreConvertedPrice\n      pdHasAllReviewsPage\n      livestreamOnPdEnabled\n      mobileGalleryZoomEnabled\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getRequestHeaders"] = oneQuery(doc, "getRequestHeaders");
        

doc.documentId = "709e3d66ed28bfd49f0332edc4e0feaf79da1bab51cdd47c29c8900729b484d2"